import {
  CmpTypographyField,
  CmpInputField,
  CmpStatus,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";
import Grid from "@mui/material/Grid";
export default function WmsFooter({
  vRdxWmsHead,
  xFooterObj,
  sArr,
  fHeadNarration,
  xKey,
  xErrorMsg,
}) {
  return (
    <div className="Wms-footer">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <CmpTypographyField xcomponent={"span"} xText={"Narration"} />
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <CmpInputField
                xtabIndex="201"
                xValue={vRdxWmsHead.A_Narr}
                xType={"text"} // text/number/password
                xName={"A_Narr"}
                xReadOnly={false}
                xOnChange={fHeadNarration}
                xError={xErrorMsg.A_Narr === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Narr}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={12} className="">
              <CmpStatus xStatus={vRdxWmsHead.A_DocStat} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={3} sm={3} md={4} lg={6}>
              <CmpTypographyField xcomponent={"span"} xText={"Cr Net Amt "} />
            </Grid>
            <Grid item xs={3} sm={3} md={8} lg={6}>
              <CmpInputField
                xtabIndex="202"
                xValue={xFooterObj.F_CrNetAmt}
                xType={"text"} // text/number/password
                xName={"A_CrNetAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={6}>
              <CmpTypographyField xcomponent={"span"} xText={"Cr Tax Amt "} />
            </Grid>
            <Grid item xs={3} sm={3} md={8} lg={4}>
              <CmpInputField
                xtabIndex="203"
                xValue={xFooterObj.F_CrTaxAmt}
                xType={"text"} // text/number/password
                xName={"F_CrTaxAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={3} sm={3} md={4} lg={6}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Rebate Net Amt"}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={8} lg={6}>
              <CmpInputField
                xtabIndex="204"
                xValue={xFooterObj.F_RebateNetAmt}
                xType={"text"} // text/number/password
                xName={"F_RebateNetAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={6}>
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Rebate Tax Amt"}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={8} lg={6}>
              <CmpInputField
                xtabIndex="205"
                xValue={xFooterObj.F_RebateTaxAmt}
                xType={"text"} // text/number/password
                xName={"F_RebateTaxAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={3} sm={3} md={4} lg={6}>
              <CmpTypographyField xcomponent={"span"} xText={"Gross "} />
            </Grid>
            <Grid item xs={3} sm={3} md={8} lg={6}>
              <CmpInputField
                xtabIndex="206"
                xValue={xFooterObj.F_GrossAmt}
                xType={"text"} // text/number/password
                xName={"F_GrossAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={6}>
              <CmpTypographyField xcomponent={"span"} xText={"Tax "} />
            </Grid>
            <Grid item xs={3} sm={3} md={8} lg={6}>
              <CmpInputField
                xtabIndex="207"
                xValue={xFooterObj.F_TaxAmt}
                xType={"text"} // text/number/password
                xName={"F_TaxAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={6}>
              <CmpTypographyField xcomponent={"span"} xText={"Net Amtount"} />
            </Grid>
            <Grid item xs={3} sm={3} md={8} lg={6}>
              <CmpInputField
                xtabIndex="208"
                xValue={xFooterObj.F_NetAmt}
                xType={"text"} // text/number/password
                xName={"F_NetAmt"}
                xReadOnly={true}
                xOnChange={""}
                xError={false}
                xErrorMessage={""}
                xTextAlign="end"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
